import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Kentucky = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="File New York State Highway Use Tax Return Online"
          description="File your New York Highway Use Tax Return online. Learn about the HUT permit, registration steps, Form MT-903 filing requirements, due dates, and penalties."
          keywords=""
          canonical="resources/excise-tax/new-york-hut/"
          ogType="article"
          jsonLdPricing="19.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="3830"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mt: 3,
          }}
        >
          <span className="highlight-container">
            <span className="highlight">New York</span>
          </span>{' '}
          Highway Use Tax (HUT)
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          Stay Compliant with New York's HUT Regulations.
        </Typography>
        {/* <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=new-york-hut`}
          >
            E-file Now!
          </Button>
        </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                }}
              >
                {/* <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  What is IRS Form 2290?
                </Typography> */}
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Box
                      itemScope
                      itemType="https://schema.org/Article"
                      sx={{
                        p: 3,
                        px: 3,
                        backgroundColor: '#f0f5f8',
                        borderLeft: '5px solid #01456c',
                        mb: 4,
                        borderRadius: 3,
                        position: 'relative',
                      }}
                    >
                      <link
                        itemProp="mainEntityOfPage"
                        href="https://www.taxzerone.com/resources/excise-tax/new-york-hut/"
                      />

                      {/* Article requires an image */}
                      <div
                        itemProp="image"
                        itemScope
                        itemType="https://schema.org/ImageObject"
                        style={{ display: 'none' }}
                      >
                        <link
                          itemProp="url"
                          href="https://www.taxzerone.com/assets/images/logo.webp"
                        />
                        <data itemProp="width" value="380" />
                        <data itemProp="height" value="124" />
                      </div>

                      <Box
                        sx={{
                          display: 'grid',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          textAlign: 'left',
                          mb: 2,
                        }}
                      >
                        <Typography variant="body2">
                          Last updated:{' '}
                          <time
                            itemProp="datePublished"
                            dateTime="2026-07-07T09:00:00-05:00"
                          >
                            July 7, 2026
                          </time>
                          <time
                            itemProp="dateModified"
                            dateTime="2026-07-07T09:00:00-05:00"
                            style={{ display: 'none' }}
                          >
                            July 7, 2026
                          </time>
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 600 }}
                          itemProp="author"
                          itemScope
                          itemType="https://schema.org/Person"
                        >
                          -by{' '}
                          <span itemProp="name">
                            <a
                              itemProp="url"
                              href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                              style={{
                                color: 'inherit',
                                textDecoration: 'none',
                              }}
                            >
                              Alexia Zepeda
                            </a>
                          </span>{' '}
                          | TaxZerone
                        </Typography>
                      </Box>

                      <Typography
                        variant="h4"
                        itemProp="headline"
                        sx={{
                          fontWeight: 600,
                          mb: 2,
                          fontSize: { md: 20, sm: 18, xs: 16 },
                          color: '#01456c',
                          fontStyle: 'italic',
                        }}
                      >
                        New York Highway Use Tax (HUT) at a Glance
                      </Typography>

                      <Box
                        component="ul"
                        itemScope
                        itemType="https://schema.org/ItemList"
                        sx={{
                          mb: 0,
                          pl: 0,
                          listStyle: 'none',

                          '& li': {
                            mb: 1.6,
                            position: 'relative',
                            pl: 3,
                          },

                          '& li::before': {
                            content: '"★"',
                            position: 'absolute',
                            left: 0,
                            top: '-2px',
                            color: '#01456c',
                            fontSize: '18px',
                          },
                        }}
                      >
                        <li
                          itemProp="itemListElement"
                          itemScope
                          itemType="https://schema.org/ListItem"
                        >
                          <data
                            itemProp="position"
                            value="1"
                            style={{ display: 'none' }}
                          />
                          <span itemProp="name">
                            <strong style={{ fontWeight: 600 }}>
                              What is HUT:
                            </strong>{' '}
                            New York Highway Use Tax applies to qualifying
                            commercial vehicles operating on{' '}
                            <strong>New York State public highways</strong> and
                            is based on vehicle weight and miles traveled.
                          </span>
                        </li>

                        <li
                          itemProp="itemListElement"
                          itemScope
                          itemType="https://schema.org/ListItem"
                        >
                          <data
                            itemProp="position"
                            value="2"
                            style={{ display: 'none' }}
                          />
                          <span itemProp="name">
                            <strong style={{ fontWeight: 600 }}>
                              Who Must File:
                            </strong>{' '}
                            Motor carriers operating qualifying vehicles with a{' '}
                            <strong>
                              New York HUT Certificate of Registration
                            </strong>{' '}
                            must file Form MT-903.
                          </span>
                        </li>

                        <li
                          itemProp="itemListElement"
                          itemScope
                          itemType="https://schema.org/ListItem"
                        >
                          <data
                            itemProp="position"
                            value="3"
                            style={{ display: 'none' }}
                          />
                          <span itemProp="name">
                            <strong style={{ fontWeight: 600 }}>
                              Registration Requirements:
                            </strong>{' '}
                            Vehicles subject to HUT must obtain a{' '}
                            <strong>
                              Certificate of Registration and decal
                            </strong>{' '}
                            before operating on New York highways.
                          </span>
                        </li>

                        <li
                          itemProp="itemListElement"
                          itemScope
                          itemType="https://schema.org/ListItem"
                        >
                          <data
                            itemProp="position"
                            value="4"
                            style={{ display: 'none' }}
                          />
                          <span itemProp="name">
                            <strong style={{ fontWeight: 600 }}>
                              Filing Frequency:
                            </strong>{' '}
                            HUT returns are generally filed{' '}
                            <strong>quarterly</strong>, but filing frequency may
                            change based on annual tax liability.
                          </span>
                        </li>

                        <li
                          itemProp="itemListElement"
                          itemScope
                          itemType="https://schema.org/ListItem"
                        >
                          <data
                            itemProp="position"
                            value="5"
                            style={{ display: 'none' }}
                          />
                          <span itemProp="name">
                            <strong style={{ fontWeight: 600 }}>
                              Tax Calculation:
                            </strong>{' '}
                            HUT is calculated using{' '}
                            <strong>miles traveled in New York</strong> and{' '}
                            <strong>vehicle weight classification</strong>.
                          </span>
                        </li>

                        <li
                          itemProp="itemListElement"
                          itemScope
                          itemType="https://schema.org/ListItem"
                        >
                          <data
                            itemProp="position"
                            value="6"
                            style={{ display: 'none' }}
                          />
                          <span itemProp="name">
                            <strong style={{ fontWeight: 600 }}>
                              Form 2290 Connection:
                            </strong>{' '}
                            Vehicles over <strong>55,000 pounds</strong> may
                            also require federal{' '}
                            <strong>Form 2290 HVUT filing</strong> and an
                            IRS-stamped Schedule 1.
                          </span>
                        </li>

                        <li
                          itemProp="itemListElement"
                          itemScope
                          itemType="https://schema.org/ListItem"
                        >
                          <data
                            itemProp="position"
                            value="7"
                            style={{ display: 'none' }}
                          />
                          <span itemProp="name">
                            <strong style={{ fontWeight: 600 }}>
                              Recordkeeping:
                            </strong>{' '}
                            Maintain trip logs, mileage records, supporting
                            documents, and{' '}
                            <Link
                              href="https://www.taxzerone.com/resources/excise-tax/form-2290-schedule-1/"
                              sx={{ color: '#0202ff' }}
                            >
                              Schedule 1
                            </Link>{' '}
                            for compliance and audits.
                          </span>
                        </li>

                        <li
                          itemProp="itemListElement"
                          itemScope
                          itemType="https://schema.org/ListItem"
                        >
                          <data
                            itemProp="position"
                            value="8"
                            style={{ display: 'none' }}
                          />
                          <span itemProp="name">
                            <strong style={{ fontWeight: 600 }}>
                              Penalties:
                            </strong>{' '}
                            Late filing, unpaid taxes, or operating without
                            proper registration may result in{' '}
                            <strong>
                              penalties, interest, fines, or registration
                              suspension
                            </strong>
                            .
                          </span>
                        </li>
                      </Box>

                      <div
                        itemProp="publisher"
                        itemScope
                        itemType="https://schema.org/Organization"
                        style={{ display: 'none' }}
                      >
                        <span itemProp="name">TaxZerone</span>
                        <div
                          itemProp="logo"
                          itemScope
                          itemType="https://schema.org/ImageObject"
                        >
                          <link
                            itemProp="url"
                            href="https://www.taxzerone.com/assets/images/logo.webp"
                          />
                          <data itemProp="width" value="380" />
                          <data itemProp="height" value="124" />
                        </div>
                      </div>
                    </Box>

                    <Typography variant="body1" sx={{ mb: 2 }}>
                      If you operate heavy motor vehicles on New York State
                      public highways, you are subject to the{' '}
                      <span style={{ fontWeight: 600 }}>Highway Use Tax</span>{' '}
                      (HUT)—alongside the federal Heavy Vehicle Use Tax (HVUT),
                      which must be filed annually using{' '}
                      <Link
                        href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        IRS Form 2290
                      </Link>{' '}
                      for vehicles over{' '}
                      <span style={{ fontWeight: 600 }}>55,000 pounds</span> of{' '}
                      <Link
                        href="/resources/excise-tax/form-2290-taxable-gross-weight-and-weight-categories/"
                        sx={{ color: '#0202ff' }}
                      >
                        gross weight
                      </Link>
                      . The HUT allows commercial motor vehicle operators to pay
                      for the upkeep of New York’s highway on the usage. As a
                      fleet owner, interstate carrier, or solo trucker, these
                      manual steps take you through everything you need to know
                      about New York HUT—permits, fees, filing requirements, and
                      penalties.
                    </Typography>
                  </Box>
                </Stack>
                <Box
                  sx={{
                    pt: 2,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <span style={{ fontWeight: 600 }}>Table of Contents</span>
                  </Typography>

                  <List
                    sx={{
                      mb: 5,
                      border: '1px solid #ccc',
                      borderRadius: 2,
                    }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#what" sx={{ color: '#0202ff' }}>
                          What is the New York Highway Use Tax (HUT)?
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#history" sx={{ color: '#0202ff' }}>
                          History and Legislative Background
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#certificate" sx={{ color: '#0202ff' }}>
                          Certificate of Registration and Decals in New York
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#how" sx={{ color: '#0202ff' }}>
                          How to Establish your account and request credentials?
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#who" sx={{ color: '#0202ff' }}>
                          Who must file Form MT-903?
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#to" sx={{ color: '#0202ff' }}>
                          How to E-File Form MT-903 New York State Highway Use
                          Tax (HUT) online?
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#cost" sx={{ color: '#0202ff' }}>
                          Cost and Fees for a HUT Permit
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#filing" sx={{ color: '#0202ff' }}>
                          Filing Requirements and Deadlines of Form MT-903
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#where" sx={{ color: '#0202ff' }}>
                          Where to mail Form MT-903?
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#calculation" sx={{ color: '#0202ff' }}>
                          How is New York HUT Calculated?
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#exemptions" sx={{ color: '#0202ff' }}>
                          Exemptions and Exclusions
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#record" sx={{ color: '#0202ff' }}>
                          Recordkeeping Requirements
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText id="what">
                        <Link href="#enforcement" sx={{ color: '#0202ff' }}>
                          Enforcement Provisions under NY HUT
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                >
                  What is the New York Highway Use Tax (HUT)?
                </Typography>
                <Box
                  component="ul"
                  sx={{ mb: 2, ml: 0, '& ul, li': { mb: 1.5 } }}
                >
                  <li>
                    The New York Highway Use Tax (HUT) is a tax imposed on motor
                    carriers operating certain commercial motor vehicles on New
                    York State public highways.
                  </li>
                  <li>
                    The tax is based on the{' '}
                    <span style={{ fontWeight: 600 }}>
                      weight of the vehicle
                    </span>{' '}
                    and the{' '}
                    <span style={{ fontWeight: 600 }}>
                      number of miles traveled
                    </span>{' '}
                    within the state. Revenue from HUT helps fund the
                    maintenance and improvement of New York’s highway
                    infrastructure.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="history"
                >
                  History and Legislative Background
                </Typography>
                <Typography id="certificate" variant="body1" sx={{ mb: 3 }}>
                  The HUT was established under{' '}
                  <span style={{ fontWeight: 600 }}>
                    Article 21 of the New York Tax Law
                  </span>{' '}
                  and has been enforced for decades as a way to fund highway
                  construction and maintenance. Over the years, the law has been
                  revised to address modern transportation needs and ensure
                  compliance among commercial carriers.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 3,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="first"
                >
                  Certificate of Registration and Decals in New York:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Before operating a motor vehicle on the public highways of New
                  York State you must obtain a certificate of registration and
                  decal for each motor vehicle subject to the highway use tax.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The{' '}
                  <span style={{ fontWeight: 600 }}>
                    two types of registrations
                  </span>{' '}
                  are:
                </Typography>

                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>
                    Any truck, tractor, or other self-propelled vehicle
                    exceeding an{' '}
                    <span style={{ fontWeight: 600 }}>18,000 pounds</span> must
                    have a HUT certificate of registration. Any truck with an
                    unloaded weight greater than 8,000 pounds, or any tractor
                    with a unloaded weight greater than 4,000 pounds will
                    require a certificate for the unloaded weight method of
                    filing returns.{' '}
                  </li>
                  <li>
                    An automotive fuel carrier (AFC) certificate of registration
                    must be issued to any truck/ trailer/ semi-trailer or
                    attached device that carries automotive fuel. The same gross
                    weight and unloaded weight rules apply.{' '}
                  </li>
                </Box>
                <Alert
                  severity="info"
                  icon={false}
                  sx={{ borderLeft: '3px solid rgb(0, 70, 102)', mb: 3 }}
                >
                  <span style={{ fontWeight: 600 }}>Tip:</span> Vehicles over
                  55,000 lbs must also{' '}
                  <Link
                    href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    file Form 2290
                  </Link>{' '}
                  for the federal HVUT—required annually, even for out-of-state
                  operators.
                </Alert>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="how"
                >
                  How to Establish your account and Request Credentials?
                </Typography>

                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>
                    Submit{' '}
                    <Link
                      target="_blank"
                      href="https://www.tax.ny.gov/pdf/current_forms/hut/tmt39_fillin.pdf"
                      sx={{ color: '#0202ff' }}
                    >
                      Form €¯TMT‑39
                    </Link>{' '}
                    (New Account Application for Highway Use Tax and Automotive
                    Fuel Carrier) to create your profile. Get your HUT
                    credentials online through the{' '}
                    <Link
                      target="_blank"
                      href="https://www.oscar.ny.gov/OSCR/OSCRCarrierHome"
                      sx={{ color: '#0202ff' }}
                    >
                      OSCAR
                    </Link>{' '}
                    (One Stop Credentialing and Registration) system.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
                  Fill Out & Mail:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>
                    Mail{' '}
                    <Link
                      target="_blank"
                      href="https://www.tax.ny.gov/bus/ads/oscar.htm"
                      sx={{ color: '#0202ff' }}
                    >
                      Form TMT-1
                    </Link>
                    €¯ (Application for Highway Use Tax (HUT) and Automotive
                    Fuel Carrier (AFC) Certificates of Registration (C of R) and
                    Decals) to the New York State Department of Taxation and
                    Finance, if you prefer traditional submission.
                  </li>
                </Box>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 3, borderLeft: '3px solid #ed6c02' }}
                >
                  <span style={{ fontWeight: 600 }}>Notes:</span> For more
                  information regarding certificate of registration and decal
                  requirements, see Tax Bulletin{' '}
                  <Link
                    target="_blank"
                    href="https://www.tax.ny.gov/pubs_and_bulls/tg_bulletins/hut/certificate_of_registration.htm"
                    sx={{ color: '#0202ff' }}
                  >
                    Certificate of Registration (TB-HU-115)
                  </Link>{' '}
                  and Tax Bulletin{' '}
                  <Link
                    target="_blank"
                    href="https://www.tax.ny.gov/pubs_and_bulls/tg_bulletins/hut/decals.htm"
                    sx={{ color: '#0202ff' }}
                  >
                    Decals - Highway Use Tax (TB-HU-160).
                  </Link>
                </Alert>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="who"
                >
                  Who must File New York Form MT-903?
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  You must file{' '}
                  <span style={{ fontWeight: 600 }}>New York Form MT-903</span>{' '}
                  if you:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>
                    Have been issued a{' '}
                    <span style={{ fontWeight: 600 }}>
                      New York HUT Certificate of Registration
                    </span>
                    , or
                  </li>
                  <li>
                    Operate qualifying motor vehicles on{' '}
                    <span style={{ fontWeight: 600 }}>
                      New York State public highways.
                    </span>
                  </li>
                </Box>
                <Typography id="to" variant="body1" sx={{ mb: 3 }}>
                  Even if you had{' '}
                  <span style={{ fontWeight: 600 }}>
                    no activity in New York during the reporting period
                  </span>
                  , you may still be required to file a return if you hold an
                  active HUT registration. Certain vehicles may qualify for
                  exemptions from HUT requirements.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="errors"
                >
                  How to E-File Form MT-903 New York State Highway Use Tax (HUT)
                  online?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  You can e-file{' '}
                  <Link
                    target="_blank"
                    href="https://www.tax.ny.gov/pdf/current_forms/motor/mt903_fill_in.pdf"
                    sx={{ color: '#0202ff' }}
                  >
                    Form MT-903
                  </Link>{' '}
                  online through the{' '}
                  <Link
                    target="_blank"
                    href="https://www.tax.ny.gov/bus/hut/webfile.htm"
                    sx={{ color: '#0202ff' }}
                  >
                    HUT Web File
                  </Link>{' '}
                  system, making it one of the quickest and most convenient ways
                  to submit your New York Highway Use Tax return and payment.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  With HUT Web File, you can:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>Receive instant electronic filing confirmation</li>
                  <li>Automatically calculate your tax due</li>
                  <li>
                    Schedule your payment up to and including the due date{' '}
                  </li>
                </Box>
                <Typography id="cost" variant="body1" sx={{ mb: 3 }}>
                  To begin, log in to your{' '}
                  <span style={{ fontWeight: 600 }}>
                    Business Online Services
                  </span>{' '}
                  account or create one if you’re a new user. For additional
                  details, visit the{' '}
                  <Link
                    target="_blank"
                    href="https://www.tax.ny.gov/"
                    sx={{ color: '#0202ff' }}
                  >
                    New York Tax Department website
                  </Link>{' '}
                  and search for “<span style={{ fontWeight: 600 }}>HUT</span>”
                  or explore the{' '}
                  <span style={{ fontWeight: 600 }}>
                    Highway Use Tax Web File
                  </span>{' '}
                  resources.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                >
                  Cost and Fees for a HUT Permit
                </Typography>

                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                  <li>
                    Application Fees{' '}
                    <Box component="ul" sx={{ mt: 1, '& li': { mb: 0.5 } }}>
                      <li>
                        There’s{' '}
                        <span style={{ fontWeight: 600 }}>
                          no fee to obtain the certificate
                        </span>{' '}
                        itself, but you may need to pay a{' '}
                        <span style={{ fontWeight: 600 }}>$1.50 decal fee</span>{' '}
                        per vehicle.{' '}
                      </li>
                    </Box>{' '}
                  </li>
                  <li>
                    Renewal Costs{' '}
                    <Box component="ul" sx={{ mt: 1, '& li': { mb: 0.5 } }}>
                      <li>
                        The HUT Certificate of Registration is valid for{' '}
                        <span style={{ fontWeight: 600 }}>three years</span> and
                        must be{' '}
                        <span style={{ fontWeight: 600 }}>
                          renewed before the expiration date.
                        </span>
                      </li>
                    </Box>{' '}
                  </li>
                  <li>
                    Additional Costs{' '}
                    <Box
                      id="filing"
                      component="ul"
                      sx={{ mt: 1, '& li': { mb: 0.5 } }}
                    >
                      <li>
                        You must file and pay HUT taxes depending on your filing
                        frequency.
                      </li>
                      <li>Costs vary based on mileage and vehicle weight.</li>
                    </Box>{' '}
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 3,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="paying"
                >
                  Filing Requirements and Deadlines of Form MT-903
                </Typography>
                <Typography id="changes" variant="body1" sx={{ mb: 3 }}>
                  You are required to file a New York HUT return and pay any tax
                  due on a <span style={{ fontWeight: 600 }}>quarterly</span>{' '}
                  basis, beginning with the calendar quarter in which you
                  started operating in New York State, unless the Tax Department
                  assigns you a different filing schedule.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 3,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="paying"
                >
                  Changes to Your HUT Filing Period
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Your New York HUT filing frequency may change after you have
                  filed quarterly returns for a full calendar year. Each year,
                  the Tax Department reviews your total{' '}
                  <span style={{ fontWeight: 600 }}>
                    Highway Use Tax liability
                  </span>{' '}
                  from the previous calendar year and will notify you if your
                  filing schedule changes.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Your filing frequency is determined as follows:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      More than $1,200 but not exceeding $12,000:
                    </span>{' '}
                    You will continue filing{' '}
                    <span style={{ fontWeight: 600 }}>quarterly</span> returns.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>More than $12,000:</span>{' '}
                    You will be reclassified as a{' '}
                    <span style={{ fontWeight: 600 }}>monthly filer.</span>
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>$1,200 or less:</span> If
                    you were subject to HUT for the entire previous calendar
                    year, you may be reclassified as an{' '}
                    <span style={{ fontWeight: 600 }}>annual filer.</span>
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 3,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="paying"
                >
                  Due Dates of Form MT-903
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                  <li>
                    If you are a{' '}
                    <span style={{ fontWeight: 600 }}>monthly filer</span>, the
                    return is due by the last day of the following month.
                  </li>
                  <li>
                    If you are a{' '}
                    <span style={{ fontWeight: 600 }}>Quarterly</span> filer:
                  </li>
                </Box>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table aria-label="Reporting Quarter Due Date Chart">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell sx={{ color: '#444', width: 300 }}>
                            Reporting Quarter
                          </TableCell>

                          <TableCell sx={{ color: '#444', width: 300 }}>
                            Filing Due Date
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell>January – March</TableCell>
                          <TableCell>
                            {' '}
                            <span style={{ fontWeight: 600 }}>April 30</span>
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>April – June</TableCell>
                          <TableCell>
                            {' '}
                            <span style={{ fontWeight: 600 }}>July 31</span>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>July – September</TableCell>
                          <TableCell>
                            {' '}
                            <span style={{ fontWeight: 600 }}>October 31</span>
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>October – December</TableCell>
                          <TableCell>
                            <span style={{ fontWeight: 600 }}>
                              January 31 (following year)
                            </span>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                  <li>
                    If you are an{' '}
                    <span style={{ fontWeight: 600 }}>annual</span> filer, file
                    by January 31 of the following year.
                  </li>
                </Box>

                <Alert
                  id="where"
                  severity="warning"
                  icon={false}
                  sx={{ borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <span style={{ fontWeight: 600 }}>Note:</span> Late penalties
                  and interest charges apply for missed deadlines. Failure to
                  file may result in revocation of your HUT certificate.
                </Alert>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 3,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                >
                  Where to mail Form MT-903?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Mail Form MT-903 to:
                </Typography>
                <Typography
                  variant="body1"
                  id="calculation"
                  sx={{
                    mb: 3,
                    border: '1px solid #ccc',
                    backgroundColor: '#e9fff6', // light highlight color
                    p: 2,
                    fontWeight: 600,
                    display: 'inline-block',
                    width: 'fit-content',
                  }}
                >
                  NYS TAX DEPARTMENT
                  <br />
                  RPC - HUT
                  <br />
                  PO BOX 15166
                  <br />
                  ALBANY NY 12212-5166
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                >
                  How is New York HUT Calculated?
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Mileage-Based System
                    </span>
                    <br />
                    The HUT is based on:
                    <Box component="ul" sx={{ mt: 1, '& li': { mb: 0.5 } }}>
                      <li>Total miles driven on New York public highways</li>
                      <li>
                        Gross vehicle weight or unloaded weight, depending on
                        classification{' '}
                      </li>
                    </Box>{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Factors That Affect Tax{' '}
                    </span>
                    <Box component="ul" sx={{ mt: 1, '& li': { mb: 0.5 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}>Weight</span> of
                        vehicle (determines tax class)
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>Distance</span>{' '}
                        traveled in NY{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Axle configuration
                        </span>{' '}
                        (optional for certain classifications){' '}
                      </li>
                    </Box>{' '}
                  </li>
                </Box>
                <Alert
                  id="exemptions"
                  severity="warning"
                  icon={false}
                  sx={{ mb: 2, borderLeft: '3px solid #ed6c02' }}
                >
                  <span style={{ fontWeight: 600 }}>Notes:</span> HUT is based
                  on mileage and weight, while{' '}
                  <span style={{ fontWeight: 600 }}>Form 2290 (HVUT)</span> is
                  based only on a vehicle’s weight and first use month. Both may
                  apply but are filed separately.
                </Alert>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    textAlign: 'left',
                    p: 2,
                    borderRadius: 2,
                    border: '1px solid #ccc',
                  }}
                >
                  <b>Example: </b> <br />A 22,000 lbs truck driving 1,000 miles
                  in NY at a tax rate of $0.024 per mile would owe $24 in HUT
                  for that period.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                >
                  Exemptions and Exclusions
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Some vehicles are{' '}
                  <span style={{ fontWeight: 600 }}>excluded</span> from Highway
                  Use Tax (HUT) registration if they are operated solely for
                  their intended purpose. Others may be{' '}
                  <span style={{ fontWeight: 600 }}>exempt</span> from HUT
                  registration if they are used{' '}
                  <span style={{ fontWeight: 600 }}>
                    exclusively for qualifying exempt activities.
                  </span>
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This bulletin outlines the types of vehicles that qualify for
                  exclusion or exemption from the tax.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="vin"
                >
                  Excluded Vehicles
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Vehicles that{' '}
                  <span style={{ fontWeight: 600 }}>
                    do not require HUT registration or taxation
                  </span>
                  , provided they are used only for their intended purpose. If
                  used otherwise, registration and tax are required for those
                  non‑excluded miles.
                </Typography>
                <Box component="div" sx={{ mb: 3 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table aria-label="Vehicle Description Chart">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell sx={{ color: '#444', width: 300 }}>
                            Vehicle
                          </TableCell>

                          <TableCell sx={{ color: '#444', width: 600 }}>
                            Description
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell>Omnibus</TableCell>
                          <TableCell>
                            A vehicle engaged in the transportation of
                            passengers for hire and regulated by the U.S.
                            Department of Transportation, the New York State
                            Department of Transportation, or any similar agency.
                            Must have seating for more than seven passengers in
                            addition to the driver.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Power shovel</TableCell>
                          <TableCell>
                            A machine that uses a bucket to dig and move
                            materials such as earth or stone. Includes backhoes,
                            front-end loaders, and wheeled excavators.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Road-building machines</TableCell>
                          <TableCell>
                            Machines used in highway construction but not
                            designed for transporting property on public roads.
                            Includes motor graders and scrapers.
                            <br />
                            <br />
                            Also includes large earth movers over 8 feet wide,
                            with pneumatic tires, used for excavation and
                            grading work.
                            <br />
                            <br />
                            Does <span style={{ fontWeight: 600 }}>
                              not
                            </span>{' '}
                            include dump trucks, tank trucks, concrete mixers,
                            or any vehicles capable of speeds over 40 mph.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Road roller</TableCell>
                          <TableCell>
                            A machine used to flatten or compact surfaces such
                            as freshly poured asphalt or earth.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Road sweeper</TableCell>
                          <TableCell>
                            A machine that removes debris from the road surface.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Sand spreader</TableCell>
                          <TableCell>
                            A truck designed to spread sand on highways. It must
                            carry no load other than sand when on a public road.
                            Devices spreading other materials do{' '}
                            <span style={{ fontWeight: 600 }}>not</span>{' '}
                            qualify.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Snow plow</TableCell>
                          <TableCell>
                            A machine specifically built for snow removal by
                            pushing, blowing, or lifting snow.
                            <br />
                            <br />A regular vehicle with an attached snow blade
                            is <span style={{ fontWeight: 600 }}>not</span>{' '}
                            considered a snow plow.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Tractor crane</TableCell>
                          <TableCell>
                            A machine capable of lifting at least three tons and
                            used for moving heavy objects like logs in off-road
                            settings.
                            <br />
                            <br />
                            Cannot be operated on highways while carrying a
                            load.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Truck crane</TableCell>
                          <TableCell>
                            A machine with a projecting swinging arm capable of
                            lifting loads at least 20 feet high.
                            <br />
                            <br />
                            Examples include:
                            <ul
                              style={{ margin: '8px 0 8px 20px', padding: 0 }}
                            >
                              <li>derricks</li>
                              <li>cherry pickers</li>
                              <li>aerial bucket trucks</li>
                              <li>concrete pumps</li>
                            </ul>
                            Note: Regular tow trucks are{' '}
                            <span style={{ fontWeight: 600 }}>not</span>{' '}
                            included.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Well driller</TableCell>
                          <TableCell>
                            A machine used to drill wells, typically a truck or
                            derrick supporting boring equipment.
                            <br />
                            <br />
                            Support vehicles like tank or pickup trucks do{' '}
                            <span style={{ fontWeight: 600 }}>not</span>{' '}
                            qualify.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="agricultural"
                >
                  Exempt Vehicles
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Vehicles that are{' '}
                  <span style={{ fontWeight: 600 }}>fully exempt from HUT</span>{' '}
                  only if exclusively used for certain specified activities. Any
                  non‑exempt usage during a calendar month triggers tax and
                  registration for that month.
                </Typography>
                <Box component="div" sx={{ mb: 3 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table aria-label="Vehicle Description Chart">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell sx={{ color: '#444', width: 300 }}>
                            Vehicle
                          </TableCell>

                          <TableCell sx={{ color: '#444', width: 600 }}>
                            Description
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell>United States mail</TableCell>
                          <TableCell>
                            Vehicles used exclusively under contract with the
                            U.S. Postal Service to transport mail.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Under the control of the government
                          </TableCell>
                          <TableCell>
                            Vehicles operated by federal, state, county, city,
                            town, or municipal agencies.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Farming</TableCell>
                          <TableCell>
                            Vehicles operated by farmers or related entities
                            used exclusively to transport:
                            <ul
                              style={{ margin: '8px 0 8px 20px', padding: 0 }}
                            >
                              <li>
                                Agricultural products grown or raised on their
                                own or adjacent farms
                              </li>
                              <li>Pulpwood or livestock</li>
                              <li>
                                Farm supplies/equipment for use on their farms
                              </li>
                            </ul>
                            See TSB-M-13(5)M for full details.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Household goods movers</TableCell>
                          <TableCell>
                            Vehicles used exclusively to move household goods
                            under authority from the NYS DOT or U.S. DOT.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Fire company</TableCell>
                          <TableCell>
                            Vehicles owned and operated by a fire company or
                            department as defined under the Volunteer
                            Firefighters’ Benefit Law.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Recreational</TableCell>
                          <TableCell>
                            Personal-use vehicles such as motor homes or
                            camper-equipped pickup trucks.
                            <br />
                            <br />
                            Must be used exclusively for non-business, personal
                            pleasure.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Transporter or dealer plates</TableCell>
                          <TableCell>
                            Vehicles operating under valid transporter or dealer
                            license plates, used only as permitted by law.
                          </TableCell>
                        </TableRow>

                        <TableRow
                          id="record"
                          sx={{ backgroundColor: '#f9f9f9' }}
                        >
                          <TableCell>Other</TableCell>
                          <TableCell>
                            Vehicles with a{' '}
                            <span style={{ fontWeight: 600 }}>
                              gross weight of 18,000 pounds or less
                            </span>
                            , unless the taxpayer opts to compute tax using the
                            unloaded weight method.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="what"
                >
                  Record keeping Requirements
                </Typography>
                <Box component="div" sx={{ mb: 3 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table aria-label="Record Keeping Requirements Chart">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell sx={{ color: '#444', width: 300 }}>
                            Requirement
                          </TableCell>

                          <TableCell sx={{ color: '#444', width: 600 }}>
                            Details
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell>Daily trip logs</TableCell>
                          <TableCell>
                            Registration number, licence plate information, VIN,
                            owner information (if leased), origin/destination,
                            total miles, and toll miles.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Mileage detail</TableCell>
                          <TableCell>
                            Separate laden and unladen miles if the gross-weight
                            method is used.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Supporting docs</TableCell>
                          <TableCell>
                            Odometer logs, dispatch sheets, fueling records,
                            bills of lading, and similar documentation.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Retention period</TableCell>
                          <TableCell>
                            Minimum of 4 years after the return due date or
                            filing date.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Storage location</TableCell>
                          <TableCell>
                            Records must remain physically in New York State
                            unless otherwise permitted.
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Audit availability</TableCell>
                          <TableCell>
                            Records must be available to the Tax Department upon
                            request.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>
                            <Link
                              href="/resources/excise-tax/form-2290-schedule-1/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 2290 Schedule 1
                            </Link>
                          </TableCell>
                          <TableCell id="enforcement">
                            Keep proof of federal HVUT payment (Form 2290
                            Schedule 1). This is often required for DMV
                            registration or audit purposes.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 87,
                  }}
                  id="what"
                >
                  Enforcement Provisions under NY HUT
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  1. Denial, Suspension, or Revocation of Registration
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                  <li>
                    The Tax Department may{' '}
                    <span style={{ fontWeight: 600 }}>
                      deny, suspend, or revoke your certificate of registration
                    </span>
                    , even without a hearing, for:
                    <Box component="ul" sx={{ mt: 1, '& li': { mb: 0.5 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}>Weight</span> of
                        vehicle (determines tax class)
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>Distance</span>{' '}
                        traveled in NY{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Axle configuration
                        </span>{' '}
                        (optional for certain classifications){' '}
                      </li>
                    </Box>{' '}
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  2. Liens, Vehicle Seizure & DMV Plate Suspension
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                  <li>
                    The Department may place a{' '}
                    <span style={{ fontWeight: 600 }}>lien</span> on your real
                    and personal property
                  </li>
                  <li>
                    Vehicles may be{' '}
                    <span style={{ fontWeight: 600 }}>
                      seized and sold at public auction
                    </span>{' '}
                    to recover unpaid taxes
                  </li>
                  <li>
                    The{' '}
                    <span style={{ fontWeight: 600 }}>
                      DMV may suspend license plates
                    </span>{' '}
                    of all associated vehicles if HUT goes unpaid
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  3. Civil Penalties
                </Typography>
                <Box component="div" sx={{ mb: 3 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table aria-label="HUT Violation Penalties Chart">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell sx={{ color: '#444', width: 300 }}>
                            Violation
                          </TableCell>

                          <TableCell sx={{ color: '#444', width: 600 }}>
                            Penalty Amount
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell>
                            Operating without required HUT registration or decal
                            (First Offense)
                          </TableCell>
                          <TableCell>
                            {' '}
                            <span style={{ fontWeight: 600 }}>
                              $500 – $2,000
                            </span>
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Repeat violation within 3 years</TableCell>
                          <TableCell>
                            {' '}
                            <span style={{ fontWeight: 600 }}>
                              $1,000 – $3,500
                            </span>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>
                            Exceeding weight limits listed on HUT certificate
                          </TableCell>
                          <TableCell>
                            Additional civil fines may apply
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  4. Criminal Penalties
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table aria-label="HUT Violation Penalties Chart">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell sx={{ color: '#444', width: 300 }}>
                            Violation Type
                          </TableCell>

                          <TableCell sx={{ color: '#444', width: 600 }}>
                            Penalty
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell>
                            Operating without HUT registration or decal
                          </TableCell>
                          <TableCell>
                            {' '}
                            <span style={{ fontWeight: 600 }}>
                              $500 – $2,000
                            </span>
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Repeat violation (within 3 years)
                          </TableCell>
                          <TableCell>
                            {' '}
                            <span style={{ fontWeight: 600 }}>
                              $1,000 – $3,500
                            </span>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Exceeding weight limits</TableCell>
                          <TableCell>Civil fines may apply</TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Minor Violations (e.g., missing decal, not keeping
                            records)
                          </TableCell>
                          <TableCell>
                            <span style={{ fontWeight: 600 }}>$100 – $250</span>{' '}
                            for first conviction
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>
                            Minor Violations (subsequent convictions)
                          </TableCell>
                          <TableCell>
                            <span style={{ fontWeight: 600 }}>$250 – $500</span>{' '}
                            or up to 10 days in jail
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Misrepresenting vehicle weight / operating after
                            decal suspension
                          </TableCell>
                          <TableCell>
                            Criminal penalties apply (fines and/or jail)
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  5. Severe Tax Fraud Consequences
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                  <li>
                    Willfully filing false returns, failing to file with intent
                    to evade, or knowingly providing false information may
                    result in felony charges under Tax Law sec.1801–1807{' '}
                  </li>
                  <li>Penalties include:</li>
                  <Box component="ul" sx={{ mt: 1, '& li': { mb: 0.5 } }}>
                    <li>
                      Up to{' '}
                      <span style={{ fontWeight: 600 }}>4 years in prison</span>
                    </li>
                    <li>
                      Fines up to{' '}
                      <span style={{ fontWeight: 600 }}>
                        $50,000 (individual)
                      </span>{' '}
                      or{' '}
                      <span style={{ fontWeight: 600 }}>
                        $250,000+ (corporation)
                      </span>
                    </li>
                  </Box>{' '}
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  6. Penalties & Interest for Late Filing or Payment
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>Late filing or payment triggers:</li>
                  <Box component="ul" sx={{ mt: 1, '& li': { mb: 0.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>10% penalty</span> of
                      the tax due, plus{' '}
                      <span style={{ fontWeight: 600 }}>1% per month</span>{' '}
                      (capped at 30%)
                    </li>
                    <li>
                      If filing is over 60 days late:{' '}
                      <span style={{ fontWeight: 600 }}>
                        $100 or the tax amount
                      </span>
                      , whichever is lower
                    </li>
                    <li>
                      Fraudulent nonpayment: penalty equals{' '}
                      <span style={{ fontWeight: 600 }}>
                        double the tax amount
                      </span>
                      , plus interest
                    </li>
                  </Box>{' '}
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  For more details Law enforcement provisions, see the Tax
                  Bulletin{' '}
                  <Link
                    target="_blank"
                    href="https://www.tax.ny.gov/pubs_and_bulls/tg_bulletins/hut/enforcement_provisions.htm"
                    sx={{ color: '#0202ff' }}
                  >
                    Summary of Enforcement provisions- Highway Use Tax
                    (TB-HU-835)
                  </Link>
                </Typography>
                <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                  <Accordion
                    defaultExpanded
                    sx={{
                      '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                        {
                          background: 'none !important',
                        },
                      '&.MuiAccordion-root': { background: 'none !important' },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls=""
                      id=""
                      sx={{
                        px: 0,
                        m: 0,
                        justifyContent: 'flex-start',
                        '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                          { m: '0 !important', flexGrow: 0 },
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          color: '#014361',
                          fontSize: 16,
                        }}
                      >
                        Source & Reference
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0 }}>
                      <Typography
                        component="div"
                        variant="body2"
                        sx={{ mt: 1 }}
                      >
                        The above information provided is based on the
                        guidelines from the{' '}
                        <Link
                          target="_blank"
                          href="https://www.tax.ny.gov/"
                          sx={{ color: '#0202ff' }}
                        >
                          New York Department of Taxation and Finance (NYSDTF)
                        </Link>
                        ,{' '}
                        <Link
                          target="_blank"
                          href="https://oscar.uscourts.gov/"
                          sx={{ color: '#0202ff' }}
                        >
                          OSCAR system
                        </Link>
                        ,{' '}
                        <Link
                          target="_blank"
                          href="https://www.nysenate.gov/legislation/laws/TAX/A21"
                          sx={{ color: '#0202ff' }}
                        >
                          New York Tax Law – Article 21
                        </Link>
                        , and the{' '}
                        <Link
                          target="_blank"
                          href="https://www.tax.ny.gov/forms/current-forms/motor/mt903i.htm"
                          sx={{ color: '#0202ff' }}
                        >
                          IRS
                        </Link>{' '}
                        Instructions of Form MT-903.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Alert>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>{' '}
    </AppLayout>
  );
};

export default Kentucky;
